import React from "react";
import { Box, Grid } from "@mui/material";
import { Label, SelectInput, VerticalFormField } from "components/common/wintForms";
import { ActionLinkButton, Icon, StaticInfoMessage } from "components/common";
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
import { SelectInputProps } from "models/propTypes/wintFormPropsTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

type FinancialStatementsApprovalSigneeSelectProps = {
  signees?: WintSuperkollAPIModelAnnualAccounts.FinancialStatementsApprovalSigneeOption[];
  loadFailed: boolean;
  onRetry: () => void;
  value?: number;
  setValue: (value?: number) => void;
};

const FinancialStatementsApprovalSigneeSelect: React.FC<FinancialStatementsApprovalSigneeSelectProps> = (props) => {
  const { signees, loadFailed, onRetry, value, setValue } = props;

  const header = LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.AnnualAccount.FinancialStatementsApprovalSigneeHeader
  );

  if (loadFailed || signees?.length === 0) {
    return (
      <Grid container direction="column" rowGap={1}>
        <Label>{header}</Label>
        <StaticInfoMessage displayType={StyleEnums.DisplayType.Info}>
          {loadFailed ? (
            <>
              {LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.AnnualAccount.FinancialStatementsApprovalSigneeLoadFailed
              )}
              <Box mt={0.5}>
                <ActionLinkButton
                  className={cssExports.animatedLink}
                  onClick={onRetry}
                  endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
                >
                  {LocalizationHelperInstance.getFormattedMessage(
                    TranslationKeys.AnnualAccount.FinancialStatementsApprovalSigneeRetry
                  )}
                </ActionLinkButton>
              </Box>
            </>
          ) : (
            LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.AnnualAccount.FinancialStatementsApprovalSigneeNoneAvailable
            )
          )}
        </StaticInfoMessage>
      </Grid>
    );
  }

  return (
    <VerticalFormField<SelectInputProps>
      Component={SelectInput}
      name="financialStatementsApprovalSignee"
      showMainLabel
      controlLabel={header}
      descriptionText={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.AnnualAccount.FinancialStatementsApprovalSigneeDescription
      )}
      items={signees?.map((signee) => ({
        value: signee.personId,
        label: signee.name ?? "",
        description: signee.role,
      }))}
      placeholder={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.AnnualAccount.FinancialStatementsApprovalSigneePlaceholder
      )}
      value={value}
      setValue={(newValue) => setValue(newValue as number | undefined)}
      onChange={() => {}}
      onBlur={() => {}}
      touched
      setTouched={() => {}}
      hasError={false}
      hideMessageBubble
      noOuterSpacing
    />
  );
};

export default FinancialStatementsApprovalSigneeSelect;
